








































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IImport } from "@/models/imports";
import Context from "@/mixins/context";

@Component
export default class UStagedRecordNotification extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public readonly importId!: IImport["id"];

  @Prop({ default: null })
  public readonly externalId!: string;

  // Computed

  public get i18nPath() {
    return this.externalId
      ? "_sentence.staged_record_notice_plus_external_id"
      : "_sentence.staged_record_notice";
  }

  public get isModalContext() {
    return this.$parent?.$el?.className?.includes("modal-card");
  }
}
